import { ApplyFilter } from "@coworker/apprestructured/src/shared/filters/types/apply";
import {
  FilterType,
  FilterValue,
  InputType,
  MultiSelectFilter,
} from "@coworker/apprestructured/src/shared/filters/types/filter";
import { useTranslation } from "@coworker/locales";
import { Article } from "../types/article";
import { formatHfbTitle } from "../Helpers/hfbHelpers";

const HFB_ID = "hfb";

function getOptions(
  t: (key: string, options?: any) => string,
  hfbDepartments: string[]
) {
  const options = hfbDepartments.map((hfb) => {
    const isHfb = hfb.match(/^[0-9]{2}$/);
    const value = isHfb ? hfb : "OTHER";
    return {
      value,
      title: formatHfbTitle(value, t),
    };
  });

  return options;
}

export function useHfbMultiSelectArticleFilter(
  hfbDepartments: string[]
): ApplyFilter<MultiSelectFilter, Article> {
  const { t } = useTranslation();
  const defaultValue = { filterId: HFB_ID, value: [] };

  return {
    filter: {
      inputType: InputType.MultiSelect,
      filterType: FilterType.Filter,
      id: HFB_ID,
      title: t("hfbString"),
      options: getOptions(t, hfbDepartments),
      enabled: true,
      showSearch: true,
      defaultValue,
    },
    filterCompare: (item: Article, { value }: FilterValue) => {
      if (!Array.isArray(value) || value.length === 0) {
        return true;
      }
      const isMatch = value.includes(item.hfb);
      const isOther = value.includes("OTHER") && !/[0-9]{2}/.test(item.hfb);
      return isMatch || isOther;
    },
  };
}
